import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  employerTagsKey,
  deleteEmployerTagsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useDeleteEmployertagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteEmployertags = ({
  setErrorText = () => { },
}: useDeleteEmployertagsProps) => {
  const client = useQueryClient();

  const { mutate: deleteTags, isLoading: isDeleteTagsLoading } =
    useMutation({
      mutationFn: (variables: {
        tag_id: number;
      }) =>
        axiosInstance
          .post(deleteEmployerTagsRoute, variables, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([employerTagsKey]);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    deleteTags,
    isDeleteTagsLoading,
  };
};
